import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ReplaySubject, Subject } from 'rxjs';
import { ManufacturerService } from '../_service/manufacturer.service';
import { filter, tap, takeUntil, debounceTime, map, delay } from 'rxjs/operators';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'manufacturerServerSearch',
  templateUrl: './manufacturerServerSearch.component.html',
  styleUrls: ['./manufacturerServerSearch.component.css']
})
export class ManufacturerServerSearchComponent implements OnInit {

  constructor(private manufacturerService: ManufacturerService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

/** list of Architect */
public manufacturer: any = [];

/** control for the selected bank for server side filtering */
public bankServerSideCtrl: FormControl = new FormControl('', [Validators.required]);
// public bankServerSideCtrl: FormControl = new FormControl();

/** control for filter for server side. */
public bankServerSideFilteringCtrl: FormControl = new FormControl('', [Validators.required]);
// public bankServerSideFilteringCtrl: FormControl = new FormControl();

/** indicate search operation is in progress */
public searching: boolean = false;

/** list of banks filtered after simulating server side search */
public  filteredServerSideBanks: ReplaySubject<any> = new ReplaySubject<any>(1);

/** Subject that emits when the component has been destroyed. */
// tslint:disable-next-line: variable-name
protected _onDestroy = new Subject<void>();
placeholder: any = null;

ngOnInit() {

  // console.log(this.bankServerSideFilteringCtrl.value);
  // console.log(this.bankServerSideFilteringCtrl);
  // console.log('This info: => ');
  // console.log(this.bankServerSideCtrl);
// listen for search field value changes
this.bankServerSideFilteringCtrl.valueChanges
.pipe(
filter(search => !!search),
tap(() => this.searching = true),
takeUntil(this._onDestroy),
debounceTime(200),
map(search => {
  console.log(search);
  return this.manufacturerService.GetManufacturerByName(search).subscribe(res => {
      this.manufacturer = res;
      // console.log(this.manufacturer);
  });
}),
delay(500)
)
.subscribe(filteredBanks => {
this.searching = false;
this.filteredServerSideBanks.next(filteredBanks);
},
error => {
// no errors in our simulated example
this.searching = false;
// handle error...
});
}

// manufacturerValidation(value) {
//   if (value) {
//     return true;
//   } else {
//     return false;
//   }
// }

getPlaceHolder() {
if (this.placeholder == null) { return 'Manufacturer'; }
return this.placeholder;
}

ngOnDestroy() {
this._onDestroy.next();
this._onDestroy.complete();
}

}

export interface Manufacturer {
  ManufacturerId: number;
  ManufacturerName: string;
}